import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import ComboBox from "../components/ComboBox";
import { UNIVERSITIES } from "../constants/universities";
import { INDUSTRIES } from "../constants/industries";
import { US_STATES } from "../constants/usStates";
import { saveProfile } from "../lib/profileStore";

const logoUrl = process.env.PUBLIC_URL + "/new_logo.png";

export default function Onboarding() {
  const { user } = useAuth();
  const navigate = useNavigate();

  const [school, setSchool] = useState("");
  const [industry, setIndustry] = useState("");
  const [role, setRole] = useState("");
  const [organization, setOrganization] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const handleSave = async (skip = false) => {
    if (!user) return;
    setSaving(true);
    setError("");
    try {
      await saveProfile(user.uid, {
        school: skip ? "" : school.trim(),
        industry: skip ? "" : industry.trim(),
        role: skip ? "" : role.trim(),
        organization: skip ? "" : organization.trim(),
        city: skip ? "" : city.trim(),
        state: skip ? "" : state.trim(),
      });

      navigate("/dashboard");
    } catch (e) {
      setError("Failed to save. Please try again.");
      setSaving(false);
    }
  };

  return (
    <div className="onboarding-page">
      <div className="onboarding-card">
        <div className="auth-brand" style={{ marginBottom: 24 }}>
          <img src={logoUrl} alt="Aline" className="logo" style={{ height: 32 }} />
        </div>

        <p className="eyebrow">Step 2 of 2</p>
        <h2 style={{ fontSize: "var(--font-lg)", fontWeight: 700, margin: "6px 0 6px" }}>
          Tell us about yourself
        </h2>
        <p style={{ fontSize: "var(--font-sm)", color: "var(--color-text-secondary)", marginBottom: 24 }}>
          These details help your connections remember you. All optional.
        </p>

        {error && <div className="error-banner" style={{ marginBottom: 16 }}>{error}</div>}

        <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          <div className="form-field">
            <label>School</label>
            <ComboBox value={school} onChange={setSchool} options={UNIVERSITIES} placeholder="e.g. Cornell University" />
          </div>
          <div className="form-field">
            <label>Industry</label>
            <ComboBox value={industry} onChange={setIndustry} options={INDUSTRIES} placeholder="e.g. Finance, Tech" />
          </div>
          <div className="form-field">
            <label>Role</label>
            <input type="text" value={role} onChange={(e) => setRole(e.target.value)} placeholder="e.g. Junior, Finance Major" />
          </div>
          <div className="form-field">
            <label>Organization or fraternity</label>
            <input
              type="text"
              value={organization}
              onChange={(e) => setOrganization(e.target.value)}
              placeholder="e.g. Alpha Phi Alpha"
            />
          </div>
          <div className="city-state-row">
            <div className="form-field">
              <label>City</label>
              <input type="text" value={city} onChange={(e) => setCity(e.target.value)} placeholder="City" />
            </div>
            <div className="form-field">
              <label>State</label>
              <ComboBox value={state} onChange={setState} options={US_STATES} placeholder="State" />
            </div>
          </div>

          <button className="btn-primary" onClick={() => handleSave(false)} disabled={saving}>
            {saving ? "Saving…" : "Save and continue"}
          </button>
          <button
            className="btn-ghost"
            onClick={() => handleSave(true)}
            disabled={saving}
            style={{ color: "var(--color-text-secondary)", borderColor: "var(--color-border)" }}
          >
            Skip for now
          </button>
        </div>
      </div>
    </div>
  );
}
